import { useTranslation } from "react-i18next";
import { ChevronDown, ChevronUp, Clock, Zap } from "lucide-react";

const categoryColors = {
  preenchedor: "bg-blue-500/20 text-blue-300 border-blue-500/30",
  bioestimulador: "bg-purple-500/20 text-purple-300 border-purple-500/30",
  laser: "bg-red-500/20 text-red-300 border-red-500/30",
  fototermolise: "bg-red-600/20 text-red-200 border-red-600/30",
  fototerapia: "bg-fuchsia-500/20 text-fuchsia-300 border-fuchsia-500/30",
  radiofrequencia: "bg-orange-500/20 text-orange-300 border-orange-500/30",
  hifu: "bg-cyan-500/20 text-cyan-300 border-cyan-500/30",
  microagulhamento: "bg-amber-500/20 text-amber-300 border-amber-500/30",
  mecanoterapia: "bg-rose-500/20 text-rose-300 border-rose-500/30",
  hifem: "bg-indigo-500/20 text-indigo-300 border-indigo-500/30",
  cirurgia: "bg-pink-500/20 text-pink-300 border-pink-500/30",
  exercicio: "bg-green-500/20 text-green-300 border-green-500/30",
  suplementacao: "bg-yellow-500/20 text-yellow-300 border-yellow-500/30",
  skincare: "bg-teal-500/20 text-teal-300 border-teal-500/30",
};

const InfoCell = ({ icon: Icon, label, value }) => (
  <div className="flex items-center gap-2">
    <Icon className="w-4 h-4 text-primary shrink-0" />
    <div>
      <p className="text-xs text-muted-foreground">{label}</p>
      <p className="text-sm text-foreground font-medium">{value}</p>
    </div>
  </div>
);

const TreatmentDetails = ({ item }) => {
  const { t } = useTranslation();
  return (
    <div className="px-5 pb-5 space-y-3 border-t border-border/50 pt-4">
      <div className="grid grid-cols-2 gap-3">
        <InfoCell icon={Clock} label={t("treatments.duration")} value={t(`treatments.durations.${item.durationKey}`)} />
        <InfoCell icon={Zap} label={t("treatments.recovery")} value={t(`treatments.recoveries.${item.recoveryKey}`)} />
      </div>
      <div>
        <p className="text-xs text-muted-foreground mb-2">{t("treatments.indicatedFor")}</p>
        <div className="flex gap-2 flex-wrap">
          {item.indications.map((ind) => (
            <span key={ind} className="text-xs bg-secondary text-muted-foreground px-2 py-1 rounded-md">
              {t(`treatments.dysfunctions.${ind}`)}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export const TreatmentCard = ({ item, expanded, onToggle }) => {
  const { t } = useTranslation();
  const Chevron = expanded ? ChevronUp : ChevronDown;
  return (
    <div className="bg-card border border-border rounded-xl overflow-hidden">
      <button onClick={onToggle} className="w-full p-5 text-left flex items-start justify-between gap-3" data-testid={`treatment-${item.id}`}>
        <div className="flex-1">
          <div className="flex items-center gap-2 flex-wrap mb-1.5">
            <h3 className="font-semibold text-foreground">{t(`treatments.items.${item.id}.name`)}</h3>
            <span className={`text-xs px-2 py-0.5 rounded-full border ${categoryColors[item.category] || 'bg-secondary text-muted-foreground border-border'}`}>
              {t(`treatments.categories.${item.category}`)}
            </span>
          </div>
          <p className="text-muted-foreground text-sm line-clamp-2">{t(`treatments.items.${item.id}.description`)}</p>
        </div>
        <Chevron className="w-4 h-4 text-muted-foreground shrink-0 mt-1" />
      </button>
      {expanded && <TreatmentDetails item={item} />}
    </div>
  );
};
